export default {
  colors: {
    white: '#fff',
    lightWhite: '#F7F9FA',
    gray: '#aaa',
    darkgray: '#505050',
    black: '#000',
    primary: '#5A00D2',
    orange: '#FF4E00',
    blue: '#27BDBE',
    purple: '#2C0560',
  },

  fonts: {
    title: 'filicudi-solid',
    paragraph: 'Helvetica',
    phrase: 'blenny',
  },
};
